import React from 'react'
import { classNameBuilder } from '@/helpers/classNameBuilder'

export type FlexProps = React.HTMLAttributes<HTMLDivElement>

export const Flex = React.forwardRef<HTMLInputElement, FlexProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div ref={ref} className={classNameBuilder('flex', className)} {...props}>
        {children}
      </div>
    )
  }
)

Flex.displayName = 'Flex'

export default Flex
